import { PayloadAction } from '@reduxjs/toolkit';
import { ChannelSettingsReducerCreator } from '../types';

const setShowEditPrimaryContactModalReducer = (create: ChannelSettingsReducerCreator) => {
  return create.reducer((state, action: PayloadAction<boolean>) => {
    state.showEditPrimaryContactModal = action.payload;
  });
};

export default setShowEditPrimaryContactModalReducer;
